import routes from '../routes/routes';

/**
 * Операції терміналу з TerminalWorkplace (лише увімкнені в ТЗ).
 */
export const getTerminalOperations = (user) => {
  const tw = user?.terminalWorkplace;
  // if (!user?.rolesTerminal || !tw) return [];
  if (!tw) return [];
  const ops = [];
  if (tw.isOrderPicking) {
    ops.push({ key: 'picking', path: routes.picking, label: 'Збірка товарів' });
  }
  if (tw.isStockChecking) {
    ops.push({ key: 'stocktake', path: routes.stocktake, label: 'Інвентаризація' });
  }
  if (tw.isPriceChecker) {
    ops.push({ key: 'price', path: routes.priceChecker, label: 'Перевірка цін' });
  }
  return ops;
};

export const terminalDefaultPath = (user) => {
  const ops = getTerminalOperations(user);
  if (ops.length === 1) return ops[0].path;
  return routes.root;
};
